module.exports = __webpack_public_path__ + "static/Petninho-33afde5102642345815e873b67c72744.png";